import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页',
      active: '/'
    }
  },
  {
    path: '/tradeArea',
    name: 'freeTradeArea ',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/tradeArea.vue'),
    meta: { title: '广西自贸区', active: '/tradeArea' }
  },
  {
    path: '/enterpriseWalkOut',
    name: 'enterpriseWalkOut',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/enterpriseWalkOut.vue'),
    meta: { title: '中国企业走出去', active: '/enterpriseWalkOut' }
  },
  {
    path: '/enterpriseComeIn',
    name: 'enterpriseComeIn',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/enterpriseComeIn.vue'),
    meta: { title: '外国企业请进来', active: '/enterpriseComeIn' }
  },
  {
    path: '/enterpriseService',
    name: 'enterpriseService',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/enterpriseService.vue'),
    meta: { title: '中国-东盟中小企业服务', active: '/enterpriseService' }
  },
  {
    path: '/aboutCenter',
    name: 'aboutCenter',
    meta: { title: '关于中心' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/aboutCenter.vue'),
    meta: { title: '关于中心', active: '/aboutCenter' }
  },
  {
    path: '/popularFeelings',
    name: 'popularFeelings',
    meta: { title: '舆情监测' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/popularFeelings.vue')
  },
  {
    path: '/reportDetails',
    name: 'reportDetails',
    meta: { title: '监测报告详情' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/reportDetails.vue')
  },
  {
    path: '/policyQuery',
    name: 'policyQuery',
    meta: { title: '政策检索' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/policyQuery.vue')
  },
  {
    path: '/policyDetails',
    name: 'policyDetails',
    meta: { title: '政策详情' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/policyDetails.vue')
  },
  {
    path: '/policyAtlas',
    name: 'policyAtlas',
    meta: { title: '政策图谱' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/policyAtlas.vue')
  },
  {
    path: '/institutionsIn',
    name: 'institutionsIn',
    meta: { title: '机构入驻' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/institutionsIn.vue')
  },

  {
    path: '/countryIntroduce',
    name: 'countryIntroduce',
    meta: { title: '东盟十国市场' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/countryIntroduce.vue')
  },
  {
    path: '/japaneseKorea',
    name: 'japaneseKorea',
    meta: { title: '日韩澳新市场' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/japaneseKorea.vue')
  },
  {
    path: '/wellKnownIndustrialPark',
    name: 'wellKnownIndustrialPark',
    meta: { title: '中国知名产业园' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/wellKnownIndustrialPark.vue')
  },
  {
    path: '/RCEPmemberState',
    name: 'RCEPmemberState',
    meta: {
      title: 'RCEP成员国简介',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/RCEPmemberState.vue')
  },

]

const router = new VueRouter({
  linkActiveClass: 'routerActive',
  routes
})

export default router
